import { RootState } from 'src/store';
import { AddSiteToPlatformFormState, AddSiteToPlatformFormUIState, defaultAddSiteToPlatformFormState } from './addSiteToPlatformSlice';

const getAddSiteToPlatformUIState = (state: RootState): AddSiteToPlatformFormUIState | null => {
    return state.habitatInsights.addSiteToPlatform.uiState || null;
};

export const getCurrentAddSiteToPlatformFormState = (state: RootState): AddSiteToPlatformFormState => {
    const currentUIState = getAddSiteToPlatformUIState(state);

    if (!currentUIState) {
        return defaultAddSiteToPlatformFormState;
    }

    return currentUIState.formState;
};
